module.exports = __webpack_public_path__ + "assets/img/PARALLEL_GATEWAY_PLUGIN.00f7a4c1.svg";